// API configuration for different environments

export const API_CONFIG = {
  development: {
    baseURL: 'http://localhost:8787' // Local worker dev server
  },
  production: {
    baseURL: 'https://ai-demistify-worker.snikotester.workers.dev'
  }
}

// Detect environment
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
export const API_BASE_URL = isDevelopment ? API_CONFIG.development.baseURL : API_CONFIG.production.baseURL

// Helper function to build API URLs
export function buildApiUrl(endpoint: string): string {
  return `${API_BASE_URL}${endpoint}`
}